<div class="friends-actions">
    <div class="actions">
        <div class="search-box">
      <span class="search-icon">
        <app-icon size="small" color="#9BB2DD" name="search"></app-icon>
      </span>
            <input [formControl]="searchFriend" type="text" placeholder="Search"/>
        </div>
    </div>
</div>

<div #scrollFriendsContainer class="grid-container" (scroll)="onFriendsScroll()">
    @for (friend of friendsList(); track friend.id) {
        <app-friend-card [selectBtn]="true" [selected]="selectedFriends.has(friend.id)" (friendChecked)="friendSelected($event, friend)"
                         [friend]="friend"></app-friend-card>
    }
</div>
